/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/camelcase */
/**
 * @ 1.23.4
 * 该文件为神策的webpageleave插件的源码修改产出物
 * 针对$WebPageLeave事件新增能力：
 *  - 可自定义设置页面停留事件名
 *  - 可异步设置一些自定义事件参数
 */
import sd from 'sa-sdk-javascript'

sd.modules['CustomPageLeave'] = (function () {
  'use strict'

  const page_hidden_status_refresh_time = 5000

  function PageLeave() {
    this.sd = null
    this.start_time = +new Date()
    this.page_show_status = true
    this.page_hidden_status = false
    this._ = {}
    this.timer = null
    this.current_page_url = document.referrer
    this.url = location.href
    this.option = {}
    this.heartbeat_interval_time = 5000
    this.heartbeat_interval_timer = null
    this.page_id = null
    // 保持和神策相同的storage_name可以随原默认事件一起补发
    this.storage_name = 'sawebjssdkpageleave'
    this.default_track_name = 'general_pageStay'
    this.custom_page_track_name = 'general_pageStay'
    this.custom_page_track_properties = {}
  }
  PageLeave.prototype.init = function (sd, option) {
    if (sd) {
      this.sd = sd
      this._ = this.sd._
      const _this = this
      if (option) {
        this.option = option

        const heartbeat_interval_time = option.heartbeat_interval_time
        if (
          heartbeat_interval_time &&
          (this._.isNumber(heartbeat_interval_time) ||
            this._.isNumber(heartbeat_interval_time * 1)) &&
          heartbeat_interval_time * 1 > 0
        ) {
          this.heartbeat_interval_time = heartbeat_interval_time * 1000
        }
        const default_track_name = option.default_track_name
        if (default_track_name) {
          this.default_track_name = default_track_name
          this.custom_page_track_name = default_track_name
        }
      }

      this.page_id = Number(
        String(this._.getRandom()).slice(2, 5) +
        String(this._.getRandom()).slice(2, 4) +
        String(new Date().getTime()).slice(-4)
      )
      _this.addEventListener()
      if (document.hidden === true) {
        this.page_show_status = false
      } else {
        _this.addHeartBeatInterval()
      }
      this.log('CustomPageLeave初始化完毕')
    } else {
      this.log('神策JS SDK未成功引入')
    }
  }
  PageLeave.prototype.log = function (message) {
    if (this.sd) {
      this.sd.log(message)
    }
  }
  PageLeave.prototype.setCurPageStayName = function (name) {
    this.custom_page_track_name = name
    this.saveHeartBeatData()
  }
  PageLeave.prototype.resetCurPageStayName = function () {
    this.custom_page_track_name = this.default_track_name
  }
  PageLeave.prototype.setCurPageProperties = function (props) {
    this.custom_page_track_properties = props
  }
  PageLeave.prototype.resetCurPageProperties = function () {
    this.custom_page_track_properties = {}
  }
  PageLeave.prototype.refreshPageEndTimer = function () {
    const _this = this
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.timer = setTimeout(function () {
      _this.page_hidden_status = false
    }, page_hidden_status_refresh_time)
  }
  PageLeave.prototype.hiddenStatusHandler = function () {
    clearTimeout(this.timer)
    this.timer = null
    this.page_hidden_status = false
  }
  PageLeave.prototype.pageStartHandler = function () {
    this.start_time = +new Date()

    if (!document.hidden === true) {
      this.page_show_status = true
    } else {
      this.page_show_status = false
    }
    this.url = location.href
  }
  PageLeave.prototype.pageEndHandler = function () {
    if (this.page_hidden_status === true) return

    const data = this.getPageLeaveProperties()
    if (this.page_show_status === false) {
      delete data.duration_time
    }
    this.page_show_status = false
    this.page_hidden_status = true
    if (this.isCollectUrl(this.url)) {
      this.sd.track(this.custom_page_track_name, data)
    }

    if (location.href !== this.url) {
      this.resetCurPageProperties()
      this.resetCurPageStayName()
    }
    this.refreshPageEndTimer()
    this.delHeartBeatData()
  }
  PageLeave.prototype.addEventListener = function () {
    this.addPageStartListener()
    this.addPageSwitchListener()
    this.addSinglePageListener()
    this.addPageEndListener()
  }
  PageLeave.prototype.addPageStartListener = function () {
    const _this = this
    if ('onpageshow' in window) {
      this._.addEvent(window, 'pageshow', function () {
        _this.pageStartHandler()
        _this.hiddenStatusHandler()
      })
    }
  }

  PageLeave.prototype.isCollectUrl = function (url) {
    if (typeof this.option.isCollectUrl === 'function') {
      if (typeof url === 'string' && url !== '') {
        return this.option.isCollectUrl(url)
      } else {
        return true
      }
    } else {
      return true
    }
  }

  PageLeave.prototype.addSinglePageListener = function () {
    const _this = this
    this.sd.ee &&
      this.sd.ee.spa.prepend('switch', function (last_url) {
        if (last_url !== location.href) {
          _this.url = last_url
          _this.pageEndHandler()
          _this.stopHeartBeatInterval()
          _this.current_page_url = _this.url
          _this.pageStartHandler()
          _this.hiddenStatusHandler()
          _this.startHeartBeatInterval()
        }
      })
  }
  PageLeave.prototype.addPageEndListener = function () {
    const _this = this
    this._.each(['pagehide', 'beforeunload', 'unload'], function (key) {
      if ('on' + key in window) {
        _this._.addEvent(window, key, function () {
          _this.pageEndHandler()

          _this.stopHeartBeatInterval()
        })
      }
    })
  }
  PageLeave.prototype.addPageSwitchListener = function () {
    const _this = this
    this._.listenPageState({
      visible: function () {
        _this.pageStartHandler()
        _this.hiddenStatusHandler()
        _this.startHeartBeatInterval()
      },
      hidden: function () {
        _this.url = location.href
        _this.pageEndHandler()
        _this.stopHeartBeatInterval()
      },
    })
  }
  PageLeave.prototype.addHeartBeatInterval = function () {
    if (!this._.localStorage.isSupport()) {
      return
    }
    this.startHeartBeatInterval()
  }
  PageLeave.prototype.startHeartBeatInterval = function () {
    const _this = this
    if (this.heartbeat_interval_timer) {
      this.stopHeartBeatInterval()
    }
    let COLLECT_URL_STATUS = true
    if (!this.isCollectUrl(this.url)) {
      COLLECT_URL_STATUS = false
    }
    this.heartbeat_interval_timer = setInterval(function () {
      COLLECT_URL_STATUS && _this.saveHeartBeatData()
    }, this.heartbeat_interval_time)
    COLLECT_URL_STATUS && this.saveHeartBeatData('is_first_heartbeat')
    this.reissueHeartBeatData()
  }
  PageLeave.prototype.stopHeartBeatInterval = function () {
    clearInterval(this.heartbeat_interval_timer)
    this.heartbeat_interval_timer = null
  }
  PageLeave.prototype.saveHeartBeatData = function (type) {
    const pageleave_properties = this.getPageLeaveProperties()
    const device_time = new Date()
    pageleave_properties.$time = device_time
    if (type === 'is_first_heartbeat') {
      pageleave_properties.duration_time = 3.14
    }

    const data = this.sd.kit.buildData({
      type: 'track',
      event: this.custom_page_track_name,
      properties: pageleave_properties,
    })

    try {
      if (this.sd.bridge.bridge_info.verify_success === 'success') {
        data.properties.$time = device_time * 1
      }
    } catch (err) {
      this.log(err.message)
    }

    data.heartbeat_interval_time = this.heartbeat_interval_time
    this.sd.store.saveObjectVal(this.storage_name + '-' + this.page_id, data)
  }
  PageLeave.prototype.delHeartBeatData = function (storage_key) {
    this._.localStorage.remove(storage_key || this.storage_name + '-' + this.page_id)
  }
  PageLeave.prototype.reissueHeartBeatData = function () {
    const storage_length = window.localStorage.length

    for (let i = storage_length - 1; i >= 0; i--) {
      const item_key = window.localStorage.key(i)
      if (
        item_key &&
        item_key !== this.storage_name + '-' + this.page_id &&
        item_key.indexOf(this.storage_name + '-') === 0
      ) {
        const item_value = this.sd.store.readObjectVal(item_key)
        if (
          this._.isObject(item_value) &&
          new Date() * 1 - item_value.time > item_value.heartbeat_interval_time + 5000
        ) {
          delete item_value.heartbeat_interval_time
          this.sd.kit.sendData(item_value)
          this.delHeartBeatData(item_key)
        }
      }
    }
  }
  PageLeave.prototype.getPageLeaveProperties = function () {
    let duration = (+new Date() - this.start_time) / 1000
    if (isNaN(duration) || duration < 0) {
      duration = 0
    }
    duration = Number(duration.toFixed(3))

    const referrer = this._.getReferrer(this.current_page_url)
    let viewport_position =
      (document.documentElement && document.documentElement.scrollTop) ||
      window.pageYOffset ||
      (document.body && document.body.scrollTop) ||
      0
    viewport_position = Math.round(viewport_position) || 0
    let data = {
      $title: document.title,
      $url: this._.getURL(this.url),
      $url_path: this._.getURLPath(this._.URL(this.url).pathname),
      $referrer_host: referrer ? this._.getHostname(referrer) : '',
      $referrer: referrer,
      $viewport_position: viewport_position,
    }
    if (duration !== 0) {
      data.duration_time = duration
    }
    if (typeof this.option.extendProps === 'function') {
      data = this._.extend(data, this.option.extendProps())
    }
    data = this._.extend(data, this.custom_page_track_properties)
    return data
  }
  const customPageLeave = new PageLeave()
  if (
    window.SensorsDataWebJSSDKPlugin &&
    Object.prototype.toString.call(window.SensorsDataWebJSSDKPlugin) === '[object Object]'
  ) {
    window.SensorsDataWebJSSDKPlugin.CustomPageLeave =
      window.SensorsDataWebJSSDKPlugin.CustomPageLeave || customPageLeave
  } else {
    window.SensorsDataWebJSSDKPlugin = {
      CustomPageLeave: customPageLeave,
    }
  }

  return customPageLeave
})()
